var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEh = function SvgEh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M1.19 6.782A11.952 11.952 0 0 0 0 11.999c0 1.87.428 3.64 1.19 5.218L12 18.26l10.81-1.043A11.953 11.953 0 0 0 24 11.999c0-1.87-.428-3.64-1.19-5.217L12 5.738 1.19 6.782Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#496E2D",
    d: "M1.191 17.218A12 12 0 0 0 12.001 24a12 12 0 0 0 10.808-6.782H1.191Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M1.191 6.782H22.81A12 12 0 0 0 12 0 12 12 0 0 0 1.191 6.782Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M3.515 3.515c-4.687 4.686-4.687 12.284 0 16.97L12 12 3.515 3.515ZM15.13 12A3.653 3.653 0 0 1 18 8.433a3.652 3.652 0 1 0 0 7.134A3.653 3.653 0 0 1 15.13 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "m18.153 9.652.518 1.595h1.677l-1.357.985.519 1.594-1.357-.985-1.356.985.518-1.594-1.356-.986h1.676l.518-1.594Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgEh;